var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoldOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 104,
    viewBox: "0 0 102 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1611 73.3514L33.4821 73.4343L8.79193 88.9878L89.397 84.9937L67.1611 73.3514Z",
    fill: "#FFC239",
    stroke: "#0D0D0D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 78.996H58.5L63 67.4961L44 64.9961V78.996Z",
    fill: "#FFC239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42.1719L44 40.996V51.9961L67.5 53.9961L71 43.496L58.5 42.4959L55 42.1719Z",
    fill: "#FFC239"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 30.4219L55 42.1719L58.5 42.4959L59 32.9219H66V30.4219H56Z",
    fill: "#FFC239"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 53.9961L44 51.9961V64.9961L63 67.4961L67.5 53.9961Z",
    fill: "#FFC239"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42.1719L44 40.996V51.9961M55 42.1719L56 30.4219H66V32.9219H59L58.5 42.4959M55 42.1719L58.5 42.4959M58.5 42.4959L71 43.496L67.5 53.9961M44 51.9961L67.5 53.9961M44 51.9961V64.9961M67.5 53.9961L63 67.4961M63 67.4961L58.5 78.996H44V64.9961M63 67.4961L44 64.9961",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldOut);
export default __webpack_public_path__ + "static/media/sold_out.8eda967dc310ccd13044bc3ec95969e2.svg";
export { ForwardRef as ReactComponent };